<template src="./show.html"></template>

<script>

import ServiceService from 'Services/ServiceService';

export default {
  data() {
    return {
      service: {},
    };
  },

  created() {
    this.detail();
  },

  methods: {
    detail() {
      ServiceService.detail(this.$route.params.id)
        .then((response) => {
          this.service = response.data;
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
pre {
     text-align: justify;
     white-space: pre-line;
};
</style>
